var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCallIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/linear/call-calling"
  }, /*#__PURE__*/React.createElement("g", {
    id: "call-calling"
  }, /*#__PURE__*/React.createElement("g", {
    id: "call-calling_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M27.573 25.7277C27.573 26.1929 27.4696 26.671 27.2499 27.1361C27.0303 27.6013 26.746 28.0406 26.3713 28.4541C25.7381 29.1519 25.0404 29.6558 24.2521 29.9789C23.4769 30.3019 22.637 30.4699 21.7325 30.4699C20.4145 30.4699 19.006 30.1598 17.5201 29.5266C16.0341 28.8935 14.5481 28.0406 13.0751 26.9682C11.5891 25.8828 10.1807 24.6811 8.83684 23.3502C7.50593 22.0063 6.30423 20.5979 5.23175 19.1248C4.17219 17.6518 3.31937 16.1787 2.69914 14.7186C2.07891 13.2456 1.7688 11.8371 1.7688 10.4933C1.7688 9.61464 1.92386 8.77474 2.23397 7.99946C2.54409 7.21125 3.0351 6.48764 3.71994 5.84157C4.54691 5.02752 5.45142 4.62695 6.4076 4.62695C6.76941 4.62695 7.13121 4.70448 7.45424 4.85954C7.7902 5.0146 8.08739 5.24718 8.31998 5.58314L11.3178 9.80846C11.5503 10.1315 11.7183 10.4287 11.8346 10.713C11.9509 10.9843 12.0155 11.2557 12.0155 11.5012C12.0155 11.8113 11.9251 12.1214 11.7442 12.4186C11.5762 12.7158 11.3307 13.0259 11.0206 13.336L10.0385 14.3568C9.8964 14.499 9.83179 14.6669 9.83179 14.8737C9.83179 14.977 9.84471 15.0675 9.87056 15.1709C9.90932 15.2742 9.94809 15.3518 9.97393 15.4293C10.2065 15.8557 10.6071 16.4113 11.1756 17.0832C11.7571 17.7552 12.3773 18.44 13.0492 19.1248C13.747 19.8097 14.4189 20.4428 15.1037 21.0243C15.7757 21.5928 16.3313 21.9805 16.7706 22.2131C16.8352 22.2389 16.9128 22.2777 17.0032 22.3164C17.1066 22.3552 17.2099 22.3681 17.3262 22.3681C17.5459 22.3681 17.7139 22.2906 17.856 22.1485L18.8381 21.1793C19.1611 20.8563 19.4712 20.6108 19.7684 20.4557C20.0656 20.2748 20.3628 20.1844 20.6858 20.1844C20.9313 20.1844 21.1898 20.2361 21.474 20.3524C21.7583 20.4687 22.0555 20.6366 22.3785 20.8563L26.6555 23.8929C26.9915 24.1254 27.2241 24.3968 27.3662 24.7198C27.4954 25.0429 27.573 25.3659 27.573 25.7277Z",
    stroke: "white",
    strokeWidth: 1.72286,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M23.0892 13.6722C23.0892 12.8969 22.4819 11.7081 21.5774 10.739C20.7504 9.84742 19.6521 9.14966 18.5667 9.14966",
    stroke: "white",
    strokeWidth: 1.72286,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M27.6117 13.672C27.6117 8.67137 23.5673 4.62695 18.5667 4.62695",
    stroke: "white",
    strokeWidth: 1.72286,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCallIcon);
export default __webpack_public_path__ + "static/media/call-icon.085a7a4f40eea02d21b75241b6f811f8.svg";
export { ForwardRef as ReactComponent };